import React from 'react';
import Hero from './Hero';
import About from './About';
import ServicesPreview from './ServicesPreview';
import WhyChooseUs from './WhyChooseUs';
import DentalTips from './DentalTips';
import EmergencyDental from './EmergencyDental';
import PatientResources from './PatientResources';
import Testimonials from './Testimonials';
import PageMeta from './PageMeta';

const Home = () => {
  return (
    <div>
      <PageMeta
        title="Phoenix Dental | Best Dentist in Vizag"
        description="Top dental clinic in Visakhapatnam offering expert dental care. Book your appointment today."
      />
      <Hero />
      <About />
      <ServicesPreview />
      <WhyChooseUs />
      <DentalTips />
      <EmergencyDental />
      <PatientResources />
      <Testimonials />
    </div>
  );
};

export default Home;
